import { Loader, UnrestrictedLoaderProps } from './loader';

type HeadlessLoaderProps<T> = Pick<
    UnrestrictedLoaderProps<T>,
    'src' | 'fallbackSrc' | 'data' | 'className' | 'retries' | 'cache' | 'onRequestError'
>;

const UnrestrictedPropsLoader = <T,>(props: UnrestrictedLoaderProps<T>) => {
    return <Loader {...props} />;
};

export function HeadlessLoader<T>(props: Readonly<HeadlessLoaderProps<T>>) {
    return (
        <UnrestrictedPropsLoader<T>
            {...props}
            isHeadless
            loadingFallback={null}
            errorFallback={null}
        />
    );
}
